<template>
	<section id="landing-page" class="no_banner_page">
    <div class="lp-logo">
      <router-link to="/">
        <span><LOGO /></span>
      </router-link>
    </div>
		<div class="mobile-banner" :style="bgCss"></div>
		<div class="container">
			<div class="contact_main">
				<h1 class="cat_title">{{ pageData.acf.title }}</h1>
				<h2 class="subtitle" v-html="pageData.acf.subtitle"></h2>
				<br />
				<hr />

				<h2 class="subtitle" id="scroll-to-after-submit">
					{{ pageData.acf.form_title }}
				</h2>
				<br />

				<div
					v-html="pageData.acf.flashy"
					class="contact_form"
				></div>
			</div>
      <div class="contact_side" :style="bgCss">
      </div>
		</div>

	</section>
</template>

<script>
  import LOGO from "../assets/img/logo.svg";
	import PHONE from "../assets/img/phone.svg";
	import WHATSAPP from "../assets/img/whatsapp.svg";
	import OK from "../assets/img/ok.svg";
	import MAIL from "../assets/img/mail.svg";
	import Slick from "vue-slick";

	export default {
		name: "LP",
		data() {
			return {
				wpData: window.wpData,
				pageData: window.wpData.pageData,
				globalOptions: window.wpData.globalOptions,
				slickOptions: {
					slidesToShow: 1,
					rtl: true,
					dots: true,
					// nextArrow: true,
					// prevArrow: true,
					adaptiveHeight: true,
					infinite: true,
					centerMode: false,
					slidesToScroll: 1,
					autoplay: false,
				},
			};
		},
		watch: {},
		methods: {},
		computed: {
			bgCss() {
				return (
					"background: #efede9 url('" +
					this.pageData.acf.bg_image.url +
					"') no-repeat center top"
				);
			},
			arrowsCss() {
				return {
					"--next-arrow":
						"url('" +
						this.wpData.assets_url +
						"/arrow_l.svg" +
						"')",
					"--prev-arrow":
						"url('" +
						this.wpData.assets_url +
						"/arrow_r.svg" +
						"')",
				};
			},
		},
		mounted() {

		},
		components: {
      LOGO,
			PHONE,
			WHATSAPP,
			OK,
			MAIL,
			Slick,
		},
	};
</script>


<style lang="scss">
.page-template-lp header#header, .page-template-lp footer.footer {
  display: none !important;
}
.page-template-lp .content {
  padding-top: 0;
}
#landing-page {
  .container {
    position: relative;
  }
  .lp-logo {
    margin-bottom: 3em;
    a {
      display: flex;
      justify-content: center;
      height: 103px;
    }
    span {
      transform: translateX(-60px);
    }
    svg {
      width: 120px;
      max-height: 120px;
      height: auto;
      position: absolute;
      left: 50%;
      background: #F8BE3A;
      border-radius: 100%;
      padding: 15px;
    }
  }

  @media (max-width: 767px) {
    .lp-logo {
      margin-bottom: 1.5em;
      padding: 1em;
    }
  }
}
</style>
<style lang="sass" scoped>
	@import '../assets/sass/abstracts.sass'

	.mobile-banner
		display: none

	.breadcrumbs
		*
			display: inline-block
			color: $dark
		.spacer
			padding: 0 0.25rem
		.current
			font-weight: bold
		.hp:hover, .hp:focus
			color: $main
			text-decoration: underline

	.subtitle
		font-size: 20px

	.serv_box
		width: 32.01rem
		.serv_wrap
			width: 100%

	.contact_main
		width: 50%

	.contact_side
		width: 50%
		background-size: contain !important

		.testimonials
			margin: 29vw auto 0 auto
			text-align: center
			max-width: 30rem
			.testimonials-title
				font-size: 24px
				font-weight: bold
				margin-bottom: 1rem
			.testimonial-item-container
				padding: 0 1rem
			.testimonial-item
				padding: 2rem 1rem
				background-color: $white
				border-radius: 0.25rem

				&:before
					display: none
				.name
					font-weight: bold
					margin-bottom: 0.5rem
	.sent
		padding: 4rem
		background: $light_main
		border: 1px solid darken($grey, 15%)
		color: $dark
		display: flex
		flex-direction: column
		justify-content: center
		align-items: center
		max-width: 470px
		.bold
			font-weight: bold
		.img
			padding: 1rem
			height: 4rem
			width: 4rem
			border-radius: 100%
			border: 1px solid $dark
			display: flex
			justify-content: center
			align-items: center
			background-color: $white
			margin-bottom: 1rem
			svg
				width: 2rem
				height: 2rem

	@media screen and (max-width:800px)
		section
			background: $grey
		.contact_main
			width: 100%
			margin-left: 0
			margin-top: 1.5rem
		.serv_box
			width: 100%
		.serv_wrap .serv_tx
			display: block
			font-size: 0.65rem

		.no_banner_page
			padding-top: 0
		.mobile-banner
			display: block
			height: 25vh
			background-size: contain !important

		.contact_side
			display: block
			background: none !important
			width: 80%
			position: relative
			margin: 0 auto

			.testimonials
				margin-top: 0
</style>

<style lang="sass">
	.testimonials
		.slick-dots
			margin-top: 1rem
			bottom: auto
		.slick-next
			background-image: var(--next-arrow)
			background-size: contain
			background-repeat: no-repeat
			transform: translateX(-0.75rem)
			&:before
				opacity: 0
		.slick-prev
			background-image: var(--prev-arrow)
			background-size: contain
			background-repeat: no-repeat
			transform: translateX(1rem)
			&:before
				opacity: 0

		@media screen and (max-width:800px)
			.slick-next
				transform: translateX(0.5rem)
			.slick-prev
				transform: translateX(0)
</style>
